import { render, staticRenderFns } from "./MenuBackButton.vue?vue&type=template&id=60b9a075&scoped=true&"
import script from "./MenuBackButton.vue?vue&type=script&lang=ts&"
export * from "./MenuBackButton.vue?vue&type=script&lang=ts&"
import style0 from "./MenuBackButton.vue?vue&type=style&index=0&id=60b9a075&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b9a075",
  null
  
)

export default component.exports